import ProTip from '../ProTip'

export default function DashboardSection() {
  return (
    <>
      <p className="text-sm text-muted-foreground mb-3">
        Your Dashboard is your morning briefing. It pulls together the numbers that matter most so
        you can start each day knowing exactly where your pipeline stands. Here is what you will
        find:
      </p>
      <ul
        className="list-disc list-inside space-y-2 text-sm text-muted-foreground ml-2"
        role="list"
      >
        <li>
          <span className="font-medium">Key metric cards</span> — Total accounts, contacts, leads,
          and open opportunities at a glance. Watch these numbers grow as your team works the
          pipeline.
        </li>
        <li>
          <span className="font-medium">Pipeline by stage</span> — A visual breakdown of how many
          deals are at each stage, from Prospecting through Closed Won. This helps you spot
          bottlenecks fast — if too many deals are stuck in one stage, it is time to take action.
        </li>
        <li>
          <span className="font-medium">Revenue analysis</span> — Track Closed Won and Closed Lost
          amounts so you can see your win rate and revenue trajectory over time.
        </li>
        <li>
          <span className="font-medium">Calls Today</span> — Track your daily call activity at a
          glance. The card shows how many calls you have logged today and this week, helping you
          stay on pace with outreach targets.
        </li>
        <li>
          <span className="font-medium">Recent activity feed</span> — See the latest updates across
          your CRM, including new records, completed tasks, and status changes. Expand or collapse
          this section as needed.
        </li>
      </ul>

      <p className="text-sm text-muted-foreground mt-3">
        <span className="font-medium">Time range &amp; data scope:</span> Use the controls at the
        top right to change the period (for example All Time or This Year) and to toggle between{' '}
        <span className="font-medium">All Data</span> and{' '}
        <span className="font-medium">My Data</span> (just your own records).{' '}
        <span className="font-medium">This Year</span> follows Grackle's fiscal year —{' '}
        <span className="font-medium">March 1 to the end of February</span> — rather than the
        calendar year.
      </p>

      <ProTip>
        <span className="font-medium">Morning routine:</span> Spend 60 seconds on your Dashboard
        before diving into calls. Check your pipeline chart for any deals that need attention, then
        head to your task list. This small habit keeps surprises to a minimum.
      </ProTip>
    </>
  )
}
